// src/components/PopoutPlayerRoute.js
import React, { useEffect } from 'react';
import { PopoutWebPlayer } from '@whitelabel/web-player';
import { resolveTenant } from '@whitelabel/utils';

const PopoutPlayerRoute = () => {
  useEffect(() => {
    document.body.classList.add('popout');
    document.body.id = 'popout-player';
    return () => {
      document.body.classList.remove('popout');
      document.body.id = '';
    };
  }, []);

  const tenantId = resolveTenant();
  const config = window.__TENANT_CFG__ || {};

  return <PopoutWebPlayer 
    session={null} // No session needed in popout for now
    config={{
      ...config,
      tenantId,
      METADATA_URL: `/api/contentmanagement/tenants/${tenantId}/metadata`
    }}
    onClose={() => window.close()}
  />;
};

export default PopoutPlayerRoute;
